module.exports = __webpack_public_path__ + "img/cyberSecu.fefb8965.jpeg";